/**
 * Google Analytics event names for the Online Quote Tool application.
 * Each step has an associated event that is tracked when the user views the page.
 */
export enum GoogleAnalyticsEventEnum {
  // Step view events
  BuildYourCourse = 'quote_step_build_your_course',
  YourInformation = 'quote_step_your_information',
  Confirmation = 'quote_step_confirmation',

  // Click events - Navigation
  QuoteBookNow = 'quote_book_now',
  QuoteSecureMyPlace = 'quote_secure_my_place',

  // Click events - Form interactions (to be expanded as features are implemented)
  QuoteCourseEdit = 'quote_course_edit',

  // Error tracking
  QuoteFormError = 'quote_form_error',
  QuoteSubmissionFailure = 'quote_submission_failure',

  // Other events
  CopyLinkClicked = 'copy_link_clicked',
  DeeplinkOpened = 'deeplink_opened',
  QuoteSaveAndClose = 'quote_save_and_close',

  // Quote update tracking
  QuoteUpdated = 'quote_updated',
}
